import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, IconButton } from "@mui/material";
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useTranslation } from "react-i18next";
import DataTable from "../../components/common/DataTable";
import CustomModal from "../../components/common/CustomModal";
import CustomMaster from "../common/CustomMaster";
import { DELETE_COMPANY_BANK, GET_COMPANY, GET_COMPANY_BANKS, UPDATE_COMPANY_BANK_STATUS, } from "../../services/apiRoutes";
import { genericGet } from "../../services/apiServices";
import MessageBox from "../common/CustomMessageBox";
import CustomDelete from "../common/CustomDeleteAlert";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { AccessDenied, hasCreatePermission, hasDeletePermission, hasEditPermission, hasViewPermission } from "../../services/CommonServices";
import CreateCompanyBank from "./CreateMasters/CreateCompanyBank";
import UpdateCompanyBank from "./UpdateMaster/UpdateCompanyBank";

const title = "Company Bank";

const CompanyBank = () => {
    const [openModal, setOpenModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [deleteAlert, setDeleteAlert] = useState(false);
    const [rowId, setRowId] = useState('');
    const [loading, setLoading] = useState(false);
    const [permission, setPermissions] = useState()
    const [getAllCompany, setGetAllCompany] = useState([]);

    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const location = useLocation();
    const currentPath = location.pathname;

    useEffect(() => {
        let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
        let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
        let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
        let createPermision = hasCreatePermission(currentPath, rolePermisionsData?.permissions)
        let viewPermision = hasViewPermission(currentPath, rolePermisionsData?.permissions)

        setPermissions({
            edit: editPermision,
            delete: deletePermission,
            create: createPermision,
            view: viewPermision,
        })
    }, [])
    const handleOpen = () => {
        setOpenModal(true);
    };
    const handleClose = () => {
        setOpenModal(false)
    }

    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);

    const [companyBankDetails, setCompanyBankDetails] = useState([])

    const handleUpdateClick = (companyBankId) => {
        setSelectedId(companyBankId);
        setUpdateModal(true);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
    };
    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true);
        setRowId(rowId);
    };


    const handleToggleStatus = async (companyBankId, currentStatus) => {
        const newStatus = currentStatus === "1" ? "0" : "1";
        const accessToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.put(
                UPDATE_COMPANY_BANK_STATUS(companyBankId),
                { activeStatus: newStatus },
                {
                    headers: { Authorization: `Bearer ${accessToken}` },
                }
            );

            if (response.status === 200) {
                setMessage({
                    open: true,
                    text: "Bank status updated successfully",
                    type: "success",
                });
                getCompanyBankDetails();
            } else {
                throw new Error("Failed to update status");
            }
        } catch (error) {
            console.error("Error updating status:", error);
            setMessage({
                open: true,
                text: "Error updating status",
                type: "error",
            });
        }
    };


    const getCompanyList = async () => {
        try {
            const response = await genericGet({ url: GET_COMPANY });

            if (response.data?.companies?.length) {
                const newData = response.data.companies.map((data) => ({
                    id: data.companyId,
                    title: data.companyName,
                }));
                setGetAllCompany(newData);
            } else {
                setGetAllCompany([]);
            }
        } catch (error) {
            console.error('Error fetching company list:', error);
            setGetAllCompany([]);
        }
    };

    const getCompanyBankDetails = async () => {
        try {
            const response = await genericGet({ url: GET_COMPANY_BANKS });
            if (response.status === 200 && response?.data?.success) {
                const responseData = response.data.data.map((bank, index) => ({
                    sn: (index + 1).toString().padStart(2, '0'),
                    companyBankId: bank.companyBankId ?? '',
                    companyId: bank.companyId ?? '',
                    userId: bank.userId ?? '',
                    bankName: bank.bankName || 'N/A',
                    accountNumber: bank.accountNumber || 'N/A',
                    accountHolderName: bank.accountHolderName || 'N/A',
                    companyName: bank.defaultcompany?.companyName || 'N/A',
                    swiftCode: bank.swiftCode || 'N/A',
                    ifscCode: bank.ifscCode || 'N/A',
                    ibanNumber: bank.ibanNumber || 'N/A',
                    bankBranch: bank.bankBranch || 'N/A',
                    bankAddress: bank.bankAddress || 'N/A',
                    country: bank.countryId || 'N/A',
                    mobile: bank.mobile || 'N/A',
                    email: bank.email || 'N/A',
                    createdAt: bank.createdAt ?? '',
                    updatedAt: bank.updatedAt ?? '',
                    activeStatus: bank.activeStatus ?? '',

                }));
                setCompanyBankDetails(responseData);
            }
        } catch (error) {
            console.error('Error fetching company bank details:', error);
        } finally {
            setLoading(false); // optional: if you're using a loading state
        }
    };
    useEffect(() => {
        getCompanyBankDetails()
        getCompanyList()
    }, [])

    const handleDelete = async (userId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_COMPANY_BANK(userId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                getCompanyBankDetails();
                setDeleteAlert(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Client Company. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the client company.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting client company", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };
    const columns = useMemo(
        () => [
            {
                accessorKey: "sn",
                header: "SN.",
                size: 50,
                tableHeader: { alignItems: "center" },
                tableStyle: { textAlign: "center" },
                enableSorting: true,
                enableColumnFilter: true,
            },
            { accessorKey: "companyName", header: "company Name", size: 200, tableHeader: { justifyContent: 'flex-start' } },
            { accessorKey: "bankName", header: "Bank Name", size: 150, tableHeader: { justifyContent: 'flex-start' } },
            { accessorKey: "accountNumber", header: "Account Number", size: 150, tableStyle: { textAlign: "center" }, },
            { accessorKey: "accountHolderName", header: "Account Holder Name", size: 150, tableHeader: { justifyContent: 'flex-start' } },
            { accessorKey: "swiftCode", header: "SWIFT Code", size: 150, tableStyle: { textAlign: "center" }, },
            { accessorKey: "ifscCode", header: "IFSC Code", size: 150, tableStyle: { textAlign: "center" }, },
            { accessorKey: "ibanNumber", header: "IBAN Number", size: 150, tableStyle: { textAlign: "center" }, },
            { accessorKey: "bankBranch", header: "Bank Branch", size: 150, tableHeader: { justifyContent: 'flex-start' } },

            {
                accessorKey: "activeStatus",
                header: "Status",
                size: 120,
                Cell: ({ row }) => {
                    const status = row.original.activeStatus;
                    const isActive = status === "1";
                    const companyBankId = row.original.companyBankId;

                    return (
                        <Button
                            variant="outlined"
                            onClick={() => handleToggleStatus(companyBankId, status)}
                            sx={{
                                color: isActive ? 'green' : 'red',
                                borderColor: isActive ? 'green' : 'red',
                                fontWeight: 100,
                                textAlign: 'center',
                                cursor: 'pointer',
                                width: "80px",
                                height: "30px",
                                fontSize: "12px",
                                textTransform: "capitalize",
                                '&:hover': {
                                    borderColor: isActive ? 'darkgreen' : 'darkred',
                                    color: isActive ? 'darkgreen' : 'darkred',
                                },
                            }}
                        >
                            {isActive ? 'Primary' : 'Secondary'}
                        </Button>
                    );
                },
                tableStyle: { textAlign: 'center' },
            },


            {
                accessorKey: "action",
                header: "Action",
                size: 50,
                Cell: ({ row }) => (
                    <div style={{ display: "flex", justifyContent: "center", gap: "4px" }}>
                        {permission?.edit && (
                            <IconButton onClick={() => handleUpdateClick(row.original.companyBankId)}>
                                <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                            </IconButton>
                        )}
                        {permission?.delete && (
                            <IconButton onClick={() => handleOpenDeleteAlert(row.original.companyBankId)}>
                                <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
                            </IconButton>
                        )}
                    </div>
                ),
            },
        ],
        [permission]
    );


    const defaultView = 'companybank';
    const mainContent = (
        <>
            <Box sx={{ padding: "10px" }}>
                <DataTable
                    title={title}
                    columns={columns}
                    data={companyBankDetails}
                    handleOpen={handleOpen}
                    buttonTitle="Create Bank Details"
                />
                <CustomModal open={openModal} handleClose={handleClose}>
                    <CreateCompanyBank
                        getCompanyBankDetails={getCompanyBankDetails}
                        getAllCompany={getAllCompany}
                        setMessage={setMessage}
                        handleClose={handleClose} />
                </CustomModal>
                <CustomModal
                    open={updateModal} handleClose={handleCloseUpdate}>
                    <UpdateCompanyBank
                        handleClose={handleCloseUpdate}
                        getAllCompany={getAllCompany}
                        companyBankId={selectedId}
                        fetchData={getCompanyBankDetails}
                        setMessage={setMessage}
                    />
                </CustomModal>
                <MessageBox
                    open={message.open}
                    onClose={() => setMessage({ ...message, open: false })}
                    message={message.text}
                    handleClose={() => setMessage({ ...message, open: false })}
                    type={message.type}
                />
                <CustomDelete
                    handleDelete={handleDelete}
                    open={deleteAlert}
                    rowId={rowId}
                    handleClose={() => setDeleteAlert(false)}
                />
            </Box>
        </>
    );
    const getMainContent = (mainContent, permission) => {
        return permission?.view ? mainContent : null;
    };

    return (

        <>
            <CustomMaster
                defaultView={defaultView}
                mainContent={getMainContent(mainContent, permission)}
            />
            {!permission?.view && <AccessDenied />}
        </>

    );
};
export default CompanyBank;
